/* eslint-disable react-hooks/exhaustive-deps */
import { v4 as uuidv4 } from "uuid";
import { useState, useEffect, useContext } from "react";
import { openDB } from "idb";
import MealSchedulingTable from "./MealSchedulingTable";
import SetupModal from "./SetupModal";
import styles from "../css/SetupForm.module.css";
import plusIcon from "../images/plus.svg";
import EditMealForm from "./EditMealForm";
import Context from "../context/context";
import { updateServiceStatus, getData } from "../utils/api";

const DEFAULT_MEAL_SCHEDULING = {
  payment_modes: [],
  customer_location: 0,
  default_mode: '0',
  meals: [
    {
      meal_uuid: "",
      meal_title: "",
      meal_status: true,
      meal_sort_order: "",
    },
  ],
};

const DEFAULT_PAYMENT_MODES = [
  {
    _id: "61b30b858ded1602f2a23320",
    maintain_customer_balance: "Y",
    outlet_wise_details: [
      {
        _id: "61e3daa107ff0d681d8e06e9",
        outlet_uuid: "outlet-uuid-1",
        status: "Loading...",
      },
      { _id: "61e3daa107ff0d681d8e06ea", outlet_uuid: "", status: "" },
    ],
    payment_mode_name: "Loading...",
    payment_mode_uuid: "1",
  },
];

export default function MealSchedulingForm({ onSave }) {
  const [mealScheduling, setMealScheduling] = useState(DEFAULT_MEAL_SCHEDULING);
  const [mealModalIndex, setMealModalIndex] = useState(null);
  const [dbPaymentModes, setDbPaymentModes] = useState(DEFAULT_PAYMENT_MODES);
  const [serviceStatus, setServiceStatus] = useState(2);
  const [online, setOnline] = useState(navigator.onLine);
  const [meals, setMeals] = useState([])
  const context = useContext(Context);
  const {
    updateUnSync
  } = context;

  useEffect(() => {
    const getData = async () => {
      const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      let tx = db.transaction("meal", "readwrite").objectStore("meal");
      let meal = await tx.getAll();
      setMeals(meal.sort((a, b) => +a.meal_sort_order - +b.meal_sort_order))
    }
    getData()
  }, [])
  useEffect(
    () =>
      (async function asyncUseEffect() {
        const db = await openDB(
          "FoodDo",
          +localStorage.getItem("IDBVersion") || 1
        );
        const paymentModeStore = db
          .transaction("payment_modes", "readonly")
          .objectStore("payment_modes");
        const paymentModes = await paymentModeStore.getAll();
        console.debug(paymentModes);
        setDbPaymentModes([
          ...paymentModes,
          { payment_mode_name: 'Cash on Delivery', payment_mode_uuid: "0", hardCoded: 1 },
          { payment_mode_name: 'UPI', payment_mode_uuid: "UPI", hardCoded: 1 },
        ]);

        const outletStore = db
          .transaction("outlet", "readonly")
          .objectStore("outlet");
        const currentOutlet = (await outletStore.getAll())[0];
        const dbMealScheduling = currentOutlet.meal_scheduling;
        const filteredDbMealScheduling = Object.fromEntries(
          Object.entries(dbMealScheduling).filter(([key]) =>
            Object.keys(DEFAULT_MEAL_SCHEDULING).includes(key)
          )
        );
        setMealScheduling(
          convertMealSchedulingFromDb({
            ...DEFAULT_MEAL_SCHEDULING,
            ...filteredDbMealScheduling,
          })
        );
        setOnline(navigator.onLine);
        const data = await getData();
        const [{ service_status }] = data.filter(
          (service) => service.service_name === "Schedule" && service
        );
        setServiceStatus(service_status.toLowerCase() === "y" ? 0 : 1);
      })(),
    []
  );

  const convertMealSchedulingToDb = () => ({
    ...mealScheduling,
    meals: meals.map((meal) => ({
      ...meal,
      meal_status: String(Number(meal.meal_status)),
    })),
  });

  const createDefaultMeal = () => ({
    meal_uuid: uuidv4(),
    outlet_uuid: localStorage.getItem("outlet_uuid"),
    new: true,
    order_types: [],
    meal_title: "New meal",
    status: "1",
    sort_order: parseInt(
      meals.length
    ),
  });

  const convertMealSchedulingFromDb = (dbMealScheduling) => ({
    ...dbMealScheduling,
    meals: meals.map((meal) => ({
      ...meal,
      meal_status: Boolean(Number(meal.meal_status)),
    })),
  });

  const handleMultipleSelections = (value) => {
    if (!mealScheduling.payment_modes.includes(value)) {
      setMealScheduling({
        ...mealScheduling,
        payment_modes: [...(
          dbPaymentModes
            ?.filter(i => mealScheduling?.payment_modes?.includes(i.payment_mode_uuid))
            ?.map(i => i.payment_mode_uuid) || []), value],
      });
    } else {
      const payment_modes = mealScheduling.payment_modes.filter(i => i !== value)
      const default_mode = mealScheduling?.default_mode === value || payment_modes?.length === 1
        ? payment_modes?.[0]
        : mealScheduling?.default_mode
      setMealScheduling({
        ...mealScheduling,
        default_mode,
        payment_modes,
      });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const outletStore = db.transaction("outlet", "readwrite").objectStore("outlet");
    const value = (await outletStore.getAll())[0];
    const updatedValue = {
      ...value,
      meal_scheduling: convertMealSchedulingToDb(),
    };

    await outletStore.put(updatedValue);
    const store = db.transaction("meal", "readwrite").objectStore("meal");

    for (let a of meals) {
      handelMealSync({ IDENTIFIER: a.meal_uuid, ...a })
      console.log(a)
      a = Object.keys(a)
        .filter((key) => key !== "new" && key !== "edit")
        .reduce((obj, key) => {
          obj[key] = a[key];
          return obj;
        }, {})
      await store.put({ IDENTIFIER: a.meal_uuid, ...a })
    }
    onSave();
  };

  const handleChange = (event) => {
    const getValue = (e) => (e.type === "checkbox" ? e.checked : e.value);
    const getSelectedValues = (e) =>
      [...e.options].filter((e) => e.selected).map((e) => e.value);

    const value = event.target.multiple
      ? getSelectedValues(event.target)
      : getValue(event.target);

    setMealScheduling({
      ...mealScheduling,
      [event.target.name]: value,
    });
  };

  const handelMealSync = async (data) => {
    if (data.edit || data.new) {

      const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      const tx = await db.transaction("unsynced_files", "readwrite").objectStore("unsynced_files");
      const ndata = {
        ...data,
        IDENTIFIER: data.new ? "meal-new:" + data.meal_uuid : "meal-edit:" + data.meal_uuid,
        RECON_TIME: Date.now(),

      };
      await tx.put(ndata);
      handleReconciliation(ndata);
      updateUnSync()
    }
  };
  const handleReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("reconciliation", "readwrite")
      .objectStore("reconciliation");
    const allReconRecords = await tx.getAll();

    const mealsJsonExists = allReconRecords.find(
      (curr) => curr.IDENTIFIER === "meal"
    );
    if (mealsJsonExists) {
      const meals = mealsJsonExists?.details?.filter(
        (meal) => meal.meal_uuid !== data.meal_uuid
      );
      const editData = {
        ...mealsJsonExists,
        details: [
          ...meals,
          {
            meal_uuid: data.meal_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.put(editData);
    } else {
      const newdata = {
        IDENTIFIER: "meal",
        details: [
          {
            meal_uuid: data.meal_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.add(newdata);
    }
  };

  const closeModal = () => setMealModalIndex(null);

  const handleStatusChange = async (e) => {
    const value = parseInt(e.target.value);
    const status = value === 0 ? "Y" : "N";
    setServiceStatus(value);
    await updateServiceStatus("Schedule", { service_status: status });
  };

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <div className={styles.heading}>
        <h1>Meal Scheduling</h1>
      </div>
      <div className={styles.formContainer}>
        <div className={styles.status}>
          <h5>Status</h5>
          <select
            name="service_status"
            disabled={!online}
            className={styles.select}
            value={serviceStatus}
            onChange={handleStatusChange}>
            {online ? (
              serviceStatus === 2 ? (
                <option value={2}>Loading...</option>
              ) : (
                <>
                  <option value={0}>Enabled</option>
                  <option value={1}>Disabled</option>
                </>
              )
            ) : (
              <option selected>Check your connection</option>
            )}
          </select>
        </div>

        <div className={styles.formGroup}>
          <h2>General</h2>

          <div className={styles.row}>
            <div className={styles.selectLabel}>
              <p style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Payment Modes</span>
                <span style={{ color: "#7f7f8b", fontSize: "small", marginTop: "8px", }}>Default</span>
              </p>
              <div className={`${styles.selections} ${styles.layout}`}>
                {Object.values(dbPaymentModes)
                  .filter(paymentMode => paymentMode.maintain_customer_balance === "Y" || paymentMode.hardCoded)
                  .map(({ payment_mode_uuid, payment_mode_name, ...paymentMode }) => {
                    const checked = mealScheduling.payment_modes.includes(payment_mode_uuid)
                    return (
                      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '5px' }}>
                        <input
                          type="checkbox"
                          name="payment-mode"
                          id={payment_mode_uuid}
                          checked={checked}
                          onChange={e => handleMultipleSelections(payment_mode_uuid)}
                          style={{ marginRight: '10px' }}
                          disabled={checked && mealScheduling.payment_modes.length === 1}
                        />
                        <label htmlFor={payment_mode_uuid} style={{ width: '100%' }}>
                          {payment_mode_name}
                        </label>
                        {checked && <input
                          type="radio"
                          name="default-payment-mode"
                          checked={mealScheduling.default_mode === payment_mode_uuid}
                          onChange={e => e.currentTarget.checked && checked && setMealScheduling(doc => ({
                            ...doc, default_mode: payment_mode_uuid
                          }))}
                        />}
                      </div>
                    )
                  })}

              </div>
            </div>

            <label className={styles.selectLabel}>
              Customer Location
              <select
                name="customer_location"
                className={styles.select}
                value={mealScheduling.customer_location}
                onChange={handleChange}>
                <option value={0}>Never ask</option>
                <option value={1}>Always ask before placing an order</option>
                <option value={2}>Ask on new address only</option>
              </select>
            </label>
          </div>
        </div>

        <MealSchedulingTable
          meals={meals}
          setMeals={setMeals}
          onMealAction={setMealModalIndex}
        />

        <button
          className={styles.addMealButton}
          onClick={() => setMeals([...meals, createDefaultMeal()])}
          type="button">
          <img src={plusIcon} alt='plus' />
        </button>

        <button type="submit" className={styles.submit}>
          Save changes
        </button>
      </div>

      {mealModalIndex !== null && (
        <SetupModal onClose={closeModal}>
          <EditMealForm
            onSave={closeModal}
            mealModalIndex={mealModalIndex}
            meals={meals}
            setMeals={setMeals}
          />
        </SetupModal>
      )}
    </form>
  );
}
